import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import { baseurl, imageUrl } from "../Baseurl";
import logo from "../component/img/logo.png";
const Categories = () => {
  const { slug } = useParams();
  const [menuData, setMenuData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchCategoryData = async () => {
    try {
      const response = await axios.get(`${baseurl}getMainMenuBySlug/${slug}`);
      const data = response.data;

      console.log("Response:", data);

      setMenuData(data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching category data:", err);
      setError("Failed to load category.");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, [slug]);

  

  return (
    <>
      <VisitorNavbar />
      <div className="container-fluid py-3">
        <div className="row g-4">
          <div className="col-md-12">
          <h4 className="product-desc-title">
  {slug
    .replace(/-\d+$/, (match) => (isNaN(match.slice(1)) ? match : "")) // Remove trailing -1, -2, -3, etc.
    .replace(/-/g, " ") // Replace hyphens with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase())} {/* Capitalize words */}
</h4>


            {loading ? (
              <div className="d-flex justify-content-center align-items-center vh-50">
                <div className="spinner-border text-danger" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : error ? (
              <p className="text-danger">{error}</p>
            ) : (
              <div className="row g-2">
                {menuData.length > 0 ? (
                  menuData.map((menu) => (
                    <div className="col-md-2 col-6 submenu-card" key={menu.id}>
                      <a
                        href={menu.is_category ? `/shop/${menu.slug}` : `/categories/${menu.slug}`}
                        className="submenu-link"
                      >
                        <div className="border rounded ht100">
                          <div className="mb-3">
                            <img
                              src={menu.image ? `${imageUrl}menu/${menu.image}` : logo}
                              alt={menu.title}
                              className="img-fluid htimg1"
                            />
                          </div>
                          <h5 className="hthed1">{menu.title}</h5>
                        </div>
                      </a>
                    </div>
                  ))
                ) : (
                  <p className="text-center text-muted minhyt">No menus found.</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Categories;
